import React, { Component } from 'react';
import {  CardElement,  injectStripe } from 'react-stripe-elements';
import RoutingConstants from 'lib/RoutingConstants'
import { post } from 'lib/api'
import { validateInputs } from 'lib/services';
import moment from 'moment';
import Loader from 'lib/loader';
import history from '../../history';

class CardForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errMessage: {},
      ...props,
      completeDetail: false,
      loadData: false,
      error: {},
      inputs: {}
    };
  }

  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ ...props })
    console.log(props)
  }
  
  
  getToken() {
    const { completeDetail, error, errMessage, inputs } = this.state
    this.setState({ loadData: true })
    if(completeDetail) {
      this.props.stripe.createToken({
        type:'card',
        name: inputs.name,
        address_city: inputs.city,
        address_line1: inputs.address,
        address_state: inputs.state,
        address_zip: inputs.zip
        
      }).then((response) => {
        if(response && response.token)
          this.payBill(response.token)
        else {
          error.cardError = true
          errMessage.cardError = 'Please use live card '
          this.setState({ error, loadData: false })  
        }
      }).catch(()=>{
        error.cardError = true
        errMessage.cardError = 'Invalid card'
        this.setState({ error, loadData: false })
      })
    } else {
      error.cardError = true
      errMessage.cardError = "Please enter valid card details"
      this.setState({ error, loadData: false })
    }
  }

  validateInput() {
    const { inputs, error, zipCode, errMessage, completeDetail } = this.state
    if (!validateInputs('alphabetics', inputs.name)) {
      errMessage.name = 'Please enter your valid name';
      error.name = true
    } else {
      error.name = false;
      errMessage.name = ""
    } 
    if (!inputs.address || inputs.address.trim()==="") {
      error.address = true;
      errMessage.address = 'Please enter your address';
    } else {
      errMessage.address = "";
      error.address = false;
    }
    if (!validateInputs('email', inputs.email)) {
      errMessage.email = 'Please enter a valid email address';
      error.email = true;
    } else {
      error.email = false;
      errMessage.email = "";
    } 
    if (!validateInputs('string', inputs.city)) {
      errMessage.city = 'Please enter city';
      error.city = true;
    } else {
      error.city = false;
      errMessage.city = "";
    }
    if (!validateInputs('alphabetics', inputs.state)) {
      error.state = true;
      errMessage.state = 'Please enter valid state';
    } else {
      error.city = false;
      errMessage.city = "";
    }
    if (!validateInputs('number', inputs.zip)) {
      error.zip = true
      errMessage.zip = 'Please enter valid ZIP code';
    } else if (inputs.zip.toString() !== zipCode.postalCode){
      error.zip = true
      errMessage.zip = 'ZIP code not match with your billing info';
    } else {
      error.zip = false;
      errMessage.zip = "";
    } 
    if(!completeDetail) {
      error.cardError = true
      errMessage.cardError = "Please enter valid card details"
    }
    this.setState({ error })
    if(!error.name && !error.address &&
       !error.zip && !error.city
       && !error.state && !error.email 
    ) { this.getToken()}
  }


  payBill(data) {
    const input = {}
    const { planId, planName, dayDates, error, errMessage } =this.state
    const url = RoutingConstants.subscribePlan;
    input.stripe_token = data.id
    input.plan_id = planId
    // input.trial_days = trialDay
    post(url, input).then(() => {
      this.setState({ loadData: true })
      const id = localStorage.getItem('email')
      window.analytics.track('New subscription', {
        planName,
        date: moment().format('dddd DD-MM-YYYY'),
        id
      });
      history.push('/billingDetails',{ dayDates })
    }).catch(err=>{
      error.cardError = true
      errMessage.cardError = err
      this.setState({ loadData: false })
    })
  }

  updateValue(event) {
    const { error } = this.state
    error.cardError = false
    this.setState({ completeDetail: event.complete, zipCode: event.value, error })
    console.log(event.value)
  }

  updateBillingValue(event) {
    const { inputs, error } = this.state
    inputs[event.target.name] = event.target.value
    error[event.target.name] = false
    this.setState({ inputs, error })
  }

  // eslint-disable-next-line
  keyPress(event) {
    if(event.keyCode === 69 ) {
      event.preventDefault()
    }
  }

  // eslint-disable-next-line
  updateCountry() {
    return false;
  }

  render() {
    const { amount, error, errMessage, loadData } = this.state;
    return (
      <div>
        {
          loadData &&
          <div className="loading">
            <Loader />
            <div className="modal-backdrop fade in custm-bkdrp" />
          </div>
        }
        <div className="user-form">
          
          <div className="user-detl-box">
            <label htmlFor="name" className={error.name  ? 'error-label' : ''}> Name </label>
            <input 
              type="text" 
              name="name" 
              placeholder="First and Last" 
              onChange={(event)=>this.updateBillingValue(event)}
              autoComplete="off"
            />
            {
              error.name !== false && <span className="error-msg">{errMessage.name}</span>
            }
          </div>   
          <div className="user-detl-box">
            <label htmlFor="email" className={error.email === true ? 'error-label' : ''}> Email </label>
            <input 
              type="email" 
              name="email" 
              placeholder="mealplan@example.com" 
              onChange={(event)=>this.updateBillingValue(event)}
            />
            {
              error.email !== false && <span className="error-msg">{errMessage.email}</span>
            }
          </div>   
          
          <div className="user-detl-box">
            <label htmlFor="address" className={error.address === true ? 'error-label' : ''}> Address </label>
            <input 
              type="text" 
              name="address" 
              placeholder= "185 Berry Street Suite 550" 
              onChange={(event)=>this.updateBillingValue(event)}
            />
            {
              error.address !== false && <span className="error-msg">{errMessage.address}</span>
            }
          </div>   
          
          <div className="user-detl-box">
            <label htmlFor="city" className={error.city === true ? 'error-label' : ''}> City </label>
            <input 
              type="text" 
              name="city" 
              placeholder="San Francisco" 
              onChange={(event)=>this.updateBillingValue(event)}
            />
            {
              error.city !== false && <span className="error-msg">{errMessage.city}</span>
            }
          </div>   
          
          <div className="user-detl-box">
            <div className="state-box">
              <label htmlFor="state" className={error.state === true ? 'error-label' : ''}> State </label>
              <input 
                type="text" 
                name="state"
                placeholder="CA" 
                onChange={(event)=>this.updateBillingValue(event)}
              />
            </div>   
            <div className="zip-box">
              <label htmlFor="zip" className={error.zip === true ? 'error-label' : ''}> Zip </label>
              <input 
                type="number" 
                name="zip" 
                placeholder="94107" 
                onKeyDown={(event)=>this.keyPress(event)}
                onChange={(event)=>this.updateBillingValue(event)}
              />
              
            </div>
            <div className="billing-err">
              {
                error.state !== false && <span className="error-msg st-err">{errMessage.state}</span>
              }
              {
                error.zip !== false && <span className="error-msg zip-err">{errMessage.zip}</span>
              }
            </div>   
          </div>  

          <div className="user-detl-box cntry">
            <label htmlFor="country"> Country </label>
            <img src="/images/usa.png" alt="usa" />
            <input type="text" name="country" value="United States" editable="false" onChange={()=>this.updateCountry()}/>
          </div>   
        </div>
        <div className="pay-form">
          <h2>Payment information</h2>
          <div className="card-dtl">
            <label className={error.cardError === true ? 'error-label': ''}> Card </label>
            <CardElement onChange={(event)=>this.updateValue(event)} />
            {
              error.cardError && <span className="error-msg"> {errMessage.cardError}</span>
            }
          </div>
        </div>
        <div className="">
          {/* <div className=""> */}
          {
            this.state.isLoading ?
              <button className="paymnt-btn">Loading...</button>
              :
              <button className="paymnt-btn" onClick={() => this.validateInput()}>Pay  {amount}</button>
          }
          {/* </div> */}
        </div>
                  
      </div>
    );
  }
}

export default injectStripe(CardForm)


// WEBPACK FOOTER //
// ./src/components/billingDetails/CardForm.js